/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Season_Winter_TextInputs */



/**
* | output |
* | --- |
* | "Winter mode is forced all year round Thermostatic valves and boiler room are in normal operation" |
*
* @param {Season_Winter_TextInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const season_winter_text = /** @type {((inputs?: Season_Winter_TextInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Season_Winter_TextInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Winter mode is forced all year round\nThermostatic valves and boiler room are in normal operation")
	return /** @type {LocalizedString} */ ("Le mode hiver est forcé toute l'année\nLes têtes th. et la chaufferie sont en fonctionnement normal")
});